'use client';
import React, { useEffect, useState } from 'react';
import AfricaComingSoon from './AfricaComingSoon';

export default function AfricaComingSoonWrapper() {
  const [countryCode, setCountryCode] = useState<string | null>(null);

  useEffect(() => {
    // Use a free IP geolocation API to detect country
    fetch('https://ipapi.co/json/')?.then((res) => res?.json())?.then((data) => {
        if (data?.country_code) {
          setCountryCode(data?.country_code);
        }
      })?.catch(() => {
        // Silently fail — banner simply won't show
      });
  }, []);

  return <AfricaComingSoon countryCode={countryCode} />;
}
